var moduleMap = {
	"./App": function() {
		return Promise.all([__webpack_require__.e(3530), __webpack_require__.e(1888), __webpack_require__.e(8577), __webpack_require__.e(829), __webpack_require__.e(272), __webpack_require__.e(6347), __webpack_require__.e(8825), __webpack_require__.e(7597), __webpack_require__.e(7691), __webpack_require__.e(2613), __webpack_require__.e(4100), __webpack_require__.e(1667), __webpack_require__.e(4303), __webpack_require__.e(8699)]).then(function() { return function() { return (__webpack_require__(3888)); }; });
	},
	"./SIVCockpit": function() {
		return Promise.all([__webpack_require__.e(1888), __webpack_require__.e(8577), __webpack_require__.e(829), __webpack_require__.e(272), __webpack_require__.e(6347), __webpack_require__.e(8825), __webpack_require__.e(7597), __webpack_require__.e(7691), __webpack_require__.e(4100), __webpack_require__.e(5220), __webpack_require__.e(5115)]).then(function() { return function() { return (__webpack_require__(2636)); }; });
	},
	"./CreateSiv": function() {
		return Promise.all([__webpack_require__.e(3530), __webpack_require__.e(829), __webpack_require__.e(6347), __webpack_require__.e(8825), __webpack_require__.e(7597), __webpack_require__.e(7691), __webpack_require__.e(2613), __webpack_require__.e(3988)]).then(function() { return function() { return (__webpack_require__(3150)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});